import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  url: 'https://auth.wiseworks-search.com/',
  clientId: 'wwp-search-frontend',
});

export default keycloak;
